import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/home/index'), hidden: true },
  { path: '/login/pmkits', component: () => import('@/views/login/pmkits'), hidden: true },
  { path: '/qrscan1', component: () => import('@/views/qrscan1/index'), hidden: true },
  { path: '/qrscan2', component: () => import('@/views/qrscan2/index'), hidden: true },
  { path: '/index', component: () => import('@/views/premium/index'), hidden: true },
  // { path: '/management', component: () => import('@/views/management/index'), hidden: true },
  // { path: '/buy', component: () => import('@/views/buy/index'), hidden: true },
  // { path: '/checkout/:code', component: () => import('@/views/buy/checkout'), hidden: true },
  // { path: '/payment', component: () => import('@/views/payment/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  // { path: '/pricing', component: () => import('@/views/pricing/index'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  // { path: '/register', component: () => import('@/views/home/register'), hidden: true },
  // { path: '/register/installer', component: () => import('@/views/home/installer'), hidden: true },
  // { path: '/register/retailer', component: () => import('@/views/home/retailer'), hidden: true },
  // { path: '/register/company', component: () => import('@/views/home/company'), hidden: true },
  { path: '/legal', component: () => import('@/views/legal/legal'), hidden: true },
  { path: '/privacy', component: () => import('@/views/legal/privacy'), hidden: true },
  { path: '/cookie', component: () => import('@/views/legal/cookie'), hidden: true }
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const approvedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const asyncRouterMap = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: 'dashboard',
    name: 'Dashboard',
    meta: { title: 'Dashboard' },
    children: [{
      path: '',
      component: () => import('@/views/admin/dashboard/index'),
      meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
    },
    {
      path: 'instance',
      component: () => import('@/views/admin/dashboard/index'),
      name: 'New Instance',
      meta: { title: 'New Instance' },
      hidden: true
    }]
  },
  {
    path: '/map',
    component: Layout,
    redirect: 'map',
    name: 'Map',
    meta: { title: 'Map' },
    children: [{
      path: '',
      component: () => import('@/views/admin/maps/index'),
      meta: { title: 'Map', icon: 'el-icon-map-location' }
    }]
  },
  // {
  //   path: '/customermap',
  //   component: Layout,
  //   redirect: 'map',
  //   name: 'Customer Map',
  //   meta: { title: 'Customer Map' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/customerlogs/index'),
  //     meta: { title: 'Customer Map', icon: 'el-icon-map-location' }
  //   }]
  // },
  {
    path: '/harvest',
    component: Layout,
    redirect: 'harvest',
    name: 'Harvesting',
    meta: { title: 'Harvesting', icon: 'el-icon-alarm-clock'  },
    children: [{
      path: '',
      component: () => import('@/views/admin/harvests/index'),
      meta: { title: 'Harvests', icon: 'el-icon-alarm-clock' }
    },
    {
      path: 'wholesale',
      component: () => import('@/views/admin/harvests/wholesale'),
      meta: { title: 'Wholesales', icon: 'el-icon-alarm-clock' }
    },
    {
      path: 'reject',
      component: () => import('@/views/admin/harvests/reject'),
      meta: { title: 'Rejects', icon: 'el-icon-alarm-clock' }
    }]
  },
  {
    path: '/shipment',
    component: Layout,
    redirect: 'deliveries',
    name: 'Shipment',
    meta: { title: 'Shipment', icon: 'el-icon-truck' },
    children: [{
      path: 'deliveries',
      component: () => import('@/views/admin/deliveries/index'),
      meta: { title: 'Deliveries', icon: 'el-icon-truck' }
    },
    {
      path: 'receivables',
      component: () => import('@/views/admin/receptions/index'),
      meta: { title: 'Receivables', icon: 'el-icon-office-building' }
    }]
  },
  {
    path: '/bentong',
    component: Layout,
    redirect: 'premium',
    name: '',
    meta: { title: 'DSR', icon: 'el-icon-office-building' },
    children: [
      {
        path: 'premium',
        component: () => import('@/views/admin/pairings/bentong'),
        meta: { title: 'Premium Durian', icon: 'el-icon-medal-1' }
      },
      {
        path: 'freshpulp',
        component: () => import('@/views/admin/freshpulps/bentong'),
        meta: { title: 'Fresh Pulp', icon: 'el-icon-medal-1' }
      },
      {
        path: 'dhlbundle',
        component: () => import('@/views/admin/dhl/bundle'),
        meta: { title: 'DHL Bundles', icon: 'el-icon-office-building' }
      }
    ]
  },
  {
    path: '/df',
    component: Layout,
    redirect: 'frozenpaste',
    name: 'DF Factory',
    meta: { title: 'DF Factory', icon: 'el-icon-office-building' },
    children: [
      {
        path: 'nitrogendurian',
        component: () => import('@/views/admin/nitrogendurians/index'),
        meta: { title: 'Nitrogen Durians', icon: 'el-icon-office-building' }
      },
      {
        path: 'freshpulp',
        component: () => import('@/views/admin/freshpulps/index'),
        meta: { title: 'Fresh Pulp', icon: 'el-icon-office-building' }
      },
      {
        path: 'frozenpulp',
        component: () => import('@/views/admin/frozenpulps/index'),
        meta: { title: 'Frozen Pulp', icon: 'el-icon-office-building' }
      },
      {
        path: 'frozenpaste',
        component: () => import('@/views/admin/frozenpastes/index'),
        meta: { title: 'Frozen Pastes', icon: 'el-icon-office-building' }
      },
      {
        path: 'frozenpastebundle',
        component: () => import('@/views/admin/frozenpastes/bundle'),
        meta: { title: 'Paste Bundles', icon: 'el-icon-office-building' }
      },
      {
        path: 'gelato',
        component: () => import('@/views/admin/gelatos/index'),
        meta: { title: 'Gelatos', icon: 'el-icon-office-building' }
      }
    ]
  },
  {
    path: '/registration',
    component: Layout,
    redirect: 'trees',
    name: 'Registration',
    meta: { title: 'Registration', icon: 'el-icon-star-off' },
    children: [
      {
        path: 'trees',
        component: () => import('@/views/admin/trees/index'),
        meta: { title: 'Trees', icon: 'el-icon-star-off' }
      },
      {
        path: 'orchards',
        component: () => import('@/views/admin/orchards/index'),
        meta: { title: 'Orchards', icon: 'el-icon-star-off' }
      }
    ]
  },
  {
    path: '/reporting',
    component: Layout,
    redirect: 'serialnumber',
    name: 'Reporting',
    meta: { title: 'Reporting', icon: 'el-icon-star-off' },
    children: [
      {
        path: 'serialnumber',
        component: () => import('@/views/admin/serialNumber/index'),
        meta: { title: 'Serial Numbers', icon: 'el-icon-star-off' }
      }
    ],
    alwaysShow: true
  },
  {
    path: '/users',
    component: Layout,
    redirect: 'drivers',
    name: 'Users',
    meta: { title: 'Users', icon: 'el-icon-user' },
    children: [
      {
        path: 'drivers',
        component: () => import('@/views/admin/users/drivers'),
        meta: { title: 'Drivers', icon: 'el-icon-truck' }
      },
      {
        path: 'supervisors',
        component: () => import('@/views/admin/users/supervisors'),
        meta: { title: 'Supervisors', icon: 'el-icon-mobile-phone' }
      },
      {
        path: 'operators',
        component: () => import('@/views/admin/users/operators'),
        meta: { title: 'Operators', icon: 'el-icon-office-building' }
      }
    ]
  },
  { path: '/manual', component: () => import('@/views/manual/index'), hidden: true },
  { path: '/apk', component: () => import('@/views/apk/index'), hidden: true }
]

export const driverRouterMap = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: 'dashboard',
    name: 'Dashboard',
    meta: { title: 'Dashboard' },
    children: [{
      path: '',
      component: () => import('@/views/admin/deliveries/driver'),
      meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
    }]
  },
  { path: '/manual', component: () => import('@/views/manual/index'), hidden: true },
  { path: '/apk', component: () => import('@/views/apk/index'), hidden: true }
]

export const supervisorRouterMap = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: 'dashboard',
    name: 'Dashboard',
    meta: { title: 'Dashboard' },
    children: [{
      path: '',
      component: () => import('@/views/admin/receptions/supervisor'),
      meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
    }]
  },
  {
    path: '/process/df',
    component: Layout,
    redirect: 'nitrogendurian',
    name: 'ProcessDF',
    meta: { title: 'DF Process', icon: 'el-icon-monitor' },
    children: [
      {
        path: 'coffee',
        component: () => import('@/views/admin/coffees/processdf'),
        meta: { title: 'Coffee', icon: 'el-icon-monitor' }
      }
    ],
    alwaysShow: true
  },
  {
    path: '/process/bentong',
    component: Layout,
    redirect: 'nitrogendurian',
    name: 'ProcessBentong',
    meta: { title: 'DSR Process', icon: 'el-icon-monitor' },
    children: [
      {
        path: 'coffee',
        component: () => import('@/views/admin/coffees/processbentong'),
        meta: { title: 'Coffee', icon: 'el-icon-monitor' }
      }
    ],
    alwaysShow: true
  },
  {
    path: '/bundle/df',
    component: Layout,
    redirect: 'nitrogendurian',
    name: 'BundleDF',
    meta: { title: 'DF Bundle', icon: 'el-icon-monitor' },
    children: [
      {
        path: 'nitrogendurian',
        component: () => import('@/views/admin/nitrogendurians/bulk'),
        meta: { title: 'Nitrogen Durians', icon: 'el-icon-monitor' }
      },
      {
        path: 'freshpulp',
        component: () => import('@/views/admin/freshpulps/bulk'),
        meta: { title: 'Fresh Pulp', icon: 'el-icon-monitor' }
      },
      {
        path: 'frozenpulp',
        component: () => import('@/views/admin/frozenpulps/bulk'),
        meta: { title: 'Frozen Pulp', icon: 'el-icon-monitor' }
      },
      {
        path: 'frozenpaste',
        component: () => import('@/views/admin/frozenpastes/bulk'),
        meta: { title: 'Frozen Pastes', icon: 'el-icon-monitor' }
      },
      {
        path: 'gelato',
        component: () => import('@/views/admin/gelatos/bulk'),
        meta: { title: 'Gelatos', icon: 'el-icon-monitor' }
      }
    ],
    alwaysShow: true
  },
  {
    path: '/bundle/bentong',
    component: Layout,
    redirect: 'freshpulp',
    name: 'BundleBentong',
    meta: { title: 'DSR Bundle', icon: 'el-icon-monitor' },
    children: [
      {
        path: 'freshpulp',
        component: () => import('@/views/admin/freshpulps/bentongbulk'),
        meta: { title: 'Fresh Pulp', icon: 'el-icon-monitor' }
      },
      {
        path: 'coffee',
        component: () => import('@/views/admin/coffees/bulk'),
        meta: { title: 'Coffees', icon: 'el-icon-monitor' }
      }
    ],
    alwaysShow: true
  },
  { path: '/manual', component: () => import('@/views/manual/index'), hidden: true },
  { path: '/apk', component: () => import('@/views/apk/index'), hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js